import { createAction, createReducer } from '@reduxjs/toolkit'

import getCookie from '../util/getCookie';

/***************
 * 
 * GET, UPDATE
 * 
 * *************/

const getPending = createAction("get/pending")
const getFulfilled = createAction("get/fulfilled")
//const getFailure = createAction("get/failure")

const get = (objectId) => {
    return (dispatch, getState) => {
        if (objectId in getState().objectsReducer.objects && (getState().objectsReducer.objects[objectId].status === "pending"||getState().objectsReducer.objects[objectId].status === "updatePending")) return
        dispatch(getPending({ "objectId": objectId }))
        fetch(objectId)
            .then(res => res.json())
            .then(data => {
                dispatch(getFulfilled({ "objectId": objectId, "object": data }))
            })
    };
}

const updatePending = createAction("update/pending")
const updateFulfilled = createAction("update/fulfilled")
const updateFailure = createAction("update/failure")

const update = (objectId, value, callback) => {
    return (dispatch, getState) => {
        dispatch(updatePending({ "objectId": objectId }))
        fetch(objectId,
            {
                method: "put",
                credentials: "same-origin",
                headers:
                {
                    "X-CSRFToken": getCookie("csrftoken"),
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    ...getAuthorizationHeader(getState)
                },
                body: JSON.stringify(value)
            }
        )
            .then(res => {
                if (res.ok) {
                    dispatch(updateFulfilled({ "objectId": objectId }))
                    callback({status:"fulfilled"})
                    dispatch(get(objectId))
                }
                else {
                    res.json().then(data => {
                        dispatch(updateFailure({ "objectId": objectId, "detail": JSON.stringify(data) }))
                        callback({status:"failure",detail:JSON.stringify(data)})
                    })
                }
            })
    };
}


const createPending = createAction("create/pending")
const createFulfilled = createAction("create/fulfilled")
const createFailure = createAction("create/failure")

const create = (objectId, value, callback) => {
    return (dispatch, getState) => {
        fetch(objectId,
            {
                method: "post",
                credentials: "same-origin",
                headers:
                {
                    "X-CSRFToken": getCookie("csrftoken"),
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    ...getAuthorizationHeader(getState)
                },
                body: JSON.stringify(value)
            }
        )
            .then(res => {
                if (res.ok) {
                    res.json().then(data => {
                        dispatch(createFulfilled({ "objectId": objectId, "id": data.id  }))
                        dispatch(get(objectId))
                        callback({status:"fulfilled", id:data.id})
                    })
                }
                else {
                    res.json().then(data => {
                        dispatch(createFailure({ "objectId": objectId, "detail": JSON.stringify(data)  }))
                        callback({status:"failure",detail:JSON.stringify(data)})
                    })
                }
            })
    };
}




const objectsReducer = createReducer({ logs: [], objects: {} }, {

    [getPending]: (state, action) => {
        console.log("getPending "+action.payload.objectId)
        const curtimes= action.payload.objectId in state.objects ? state.objects[action.payload.objectId].times : 0
        if (!(action.payload.objectId in state.objects))
            state.objects[action.payload.objectId]={}
        state.objects[action.payload.objectId].status="pending"
        state.objects[action.payload.objectId].times=curtimes+1
    },

    [getFulfilled]: (state, action) => {
        console.log("getFulfilled "+action.payload.objectId)
        state.objects[action.payload.objectId].status= "fulfilled"
        state.objects[action.payload.objectId].data=action.payload.object
    },

    [updatePending]: (state, action) => {
        console.log("updatePending "+action.payload.objectId)
        const curtimes= action.payload.objectId in state.objects ? state.objects[action.payload.objectId].times : 0
        state.objects[action.payload.objectId].status = "updatePending"
        state.objects[action.payload.objectId].times=curtimes+1
    },

    [updateFulfilled]: (state, action) => {
        console.log("updateFulfilled "+action.payload.objectId)
        state.objects[action.payload.objectId].status = "updateFulfilled"
    },

    [updateFailure]: (state, action) => {
        console.log("updateFailure: " + action.payload.detail)
        state.objects[action.payload.objectId].status= "updateFailure"
        state.objects[action.payload.objectId].detail= action.payload.detail 
    },

    [createPending]: (state, action) => {
        console.log("createPending :"+action.payload.objectId)
    },

    [createFulfilled]: (state, action) => {
        console.log("createFulfilled :"+action.payload.objectId)
    },

    [createFailure]: (state, action) => {
        console.log("createFailure: " + action.payload.detail)
    }

})


/***************
 * 
 * LOGIN
 * 
 * *************/

const tokenPending = createAction("login/tokenPending")
const tokenFulfilled = createAction("login/tokenFulfilled")
const getProfilePending = createAction("login/getProfilePending")
const getProfileFulfilled = createAction("login/getProfileFulfilled")
const loginFailure = createAction("login/loginFailure")
const logout = createAction("login/logout")


const login = (param) => {
    return (dispatch, getState) => {
        dispatch(tokenPending())
        fetch("api/token/",
            {
                method: "post",
                credentials: "same-origin",
                headers:
                {
                    "X-CSRFToken": getCookie("csrftoken"),
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(param)
            }
        )
            .then(res => {
                if (res.ok) {
                    return res.json()
                }
                else {
                    dispatch(loginFailure("login(), bad http"))
                }
            })
            .then(data => {

                if (typeof data === 'undefined') {
                    return
                }

                if ("access" in data) {
                    dispatch(tokenFulfilled(data))
                    dispatch(getProfile())
                }
                else {
                    dispatch(loginFailure("login(), no access in data"))
                }
            })

    };

}

const getProfile = () => {
    return (dispatch, getState) => {
        dispatch(getProfilePending())
        fetch("api/profile/",
            {
                method: "get",
                credentials: "same-origin",
                headers:
                {
                    "X-CSRFToken": getCookie("csrftoken"),
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    ...getAuthorizationHeader(getState)
                }
            }
        ).then(res => {
            if (res.ok) {
                return res.json()
            }
            else {
                dispatch(loginFailure("getProfile(), bad http answer"))
            }
        })
            .then(data => {
                if (typeof data === 'undefined') {
                    return
                }
                if ("error" in data) {
                    dispatch(loginFailure("getProfile(), error in data"))
                    return
                }
                dispatch(getProfileFulfilled(data))
            })

    };
}

const loginReducer = createReducer({ loginStatus: "", logged: false, tokenObtained: false, profileId: "UNKNOWN" }, {

    [tokenPending]: (state, action) => {
        state.loginStatus = "loginPending"
        state.profileId = "UNKNOWN"
        state.logged = false
        state.tokenObtained = false
    },

    [tokenFulfilled]: (state, action) => {
        state.loginStatus = "loginFulfilled"
        state.token = action.payload.access
        state.refresh = action.payload.refresh
        state.tokenObtained = true
    },

    [getProfilePending]: (state, action) => {
        state.loginStatus = "getProfilePending"
    },

    [getProfileFulfilled]: (state, action) => {
        state.loginStatus = "getProfileFulfilled"
        state.profile = action.payload
        state.logged = true
    },

    [loginFailure]: (state, action) => {
        state.loginStatus = "fail"
        state.logged = false
        state.tokenObtained = false
        console.log(action.payload)
    },

    [logout]: (state, action) => {
        state.loginStatus = ""
        state.logged = false
        state.tokenObtained = false
    }

})

// header to be included in http, to include login info if available
const getAuthorizationHeader = (getState) => {
    if (getState().loginReducer.tokenObtained) {
        return { "Authorization": "Bearer " + getState().loginReducer.token }
    }
    else
        return {}
}


export { objectsReducer, get, loginReducer, login, logout, update, create }